//tesourinhos-mvp/frontend/src/pages/DashboardAdmin.jsx
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import AppShell from "../components/app-shell/AppShell";
import { computeCadastrosKpi, parseInitialCadastrosTab, isBaba, isFamilia } from "./dashboardAdminKpi";
import { Card, CardHeader, CardTitle, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Input as ShadInput } from "../components/ui/input";
import { Button as ShadButton } from "../components/ui/button";
import { Label } from "../components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../components/ui/select";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from "../components/ui/alert-dialog";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "../components/ui/table";
import { Checkbox } from "../components/ui/checkbox";
import { cn } from "../lib/utils";
import "./dashboards.css";

// Importa o novo componente de Conteúdo Financeiro

import PlanosTable from "../components/PlanosTable";
import PacotesTable from "../components/PacotesTable";

// Importa os formulários para edição via Admin
import AdminEditForm from "../auth/cadastro";
import DocumentsViewer from "../shared/documents/DocumentsViewer";

import { uploadToStorage } from "../utils/uploadToStorage";
import { getBabaPhotoCandidates, handleBabaPhotoError } from "../utils/babaPhoto.js";
import AdminResumoCards from "../pages/cards/AdminResumoCards";
import AdminAgendamentos from "../pages/cards/AdminAgendamentos";
import AssinaturasAdminContent from "../features/dashboard-admin/AssinaturasAdminContent.jsx";
import AssinaturasMPContent from "../features/dashboard-admin/AssinaturasMPContent.jsx";
import SolicitacoesAdminContent from "../features/dashboard-admin/SolicitacoesAdminContent.jsx";
import AdminProfileSection from "../features/dashboard-admin/profile/AdminProfileSection.jsx";
import {
  getAgendamentos,
  alterarStatus,
  cancelarAgendamento,
} from "./supabaseService";

// Ícones para o novo menu lateral
import {
  Eye,
  X,
  LayoutDashboard,
  Users,
  Shield,
  SquareUserRound,
  Wallet,
  EyeOff,
  MoreVertical,
  Settings,
  LogOut,
  FileText, // Ícone para documentos
  FileEdit, // Ícone para conteúdo
  User, // Ícone geral de usuário
  Clock, // Adicionado para indicar 'pendente'
  CheckCircle,
  XCircle,
  UploadCloud,
  Plus,
  Camera,
  Edit,
  Trash2,
  Briefcase,
  Package, // Adicionado o ícone Package
  Search,
  Trash,
} from "lucide-react";
// ----------------------------------------------------
// VARIÁVEIS DE CONFIGURAÇÃO DO STORAGE DE DOCUMENTOS
// ----------------------------------------------------
// Bucket único de produção: todos os uploads (fotos, docs, certificados) vão
// para 'cadastros' via uploadToStorage. Os nomes antigos (foto-documento-frente,
// self-documento, documentos...) apontavam para buckets que não existem, então a
// assinatura das URLs falhava mesmo com documentos_url preenchido.
const BUCKET_FRENTE_DOC = "cadastros";
const BUCKET_VERSO_DOC = "cadastros";
const BUCKET_SELFIE_DOC = "cadastros";
const BUCKET_DOCUMENTO_FAMILIA = "cadastros"; // Usado por VerificadorIdentidade para familias
const PLACEHOLDER_URL = "/assets/logo-tesourinhos-trans.png"; //forma correta não alterar
const BUCKET_DOCUMENTOS = "cadastros"; // antecedentes criminais e certificados
const BUCKET_FOTO_BABAS = "cadastros"; // Bucket único de produção
const BUCKET_FOTO_FAMILIA = "cadastros"; // Bucket único de produção
const NOME_CAMPO_DB = "documentos_url"; // Coluna JSONB na tabela 'usuarios' (babas e familias)

//// ---------------------------------------------------
// FUNÇÃO AUXILIAR CORRIGIDA (V4) - MAIS ROBUSTA
// Garante que só o caminho DENTRO do bucket seja retornado,
// independentemente de ele estar completo (URL) ou parcial (com o nome do bucket).
// ----------------------------------------------------

// Uploads via backend foram removidos. Use `uploadToStorage(file, folderType)` para uploads diretos ao Supabase Storage.

const getRelativePath = (path, bucketName) => {
  if (!path) return null;
  let relativePath = path;

  const regex = new RegExp(
    `.*/storage/v1/object/(?:public|sign)/${bucketName}/`,
  );

  if (relativePath.match(regex)) {
    relativePath = relativePath.replace(regex, "");
  }

  if (relativePath.startsWith(`${bucketName}/`)) {
    relativePath = relativePath.substring(bucketName.length + 1);
  }

  if (relativePath.startsWith("/")) {
    relativePath = relativePath.substring(1);
  }

  if (
    relativePath === "" ||
    relativePath === "undefined" ||
    relativePath === "null"
  ) {
    return null;
  }

  return relativePath;
};

// ----------------------------------------------------
// Componente de Card de Babá para Verificação (Atualizado com log de erro)
// ----------------------------------------------------
const DocumentVerificationCard = ({ baba, onStatusChange }) => {
  const [loading, setLoading] = useState(false);
  const [documentUrls, setDocumentUrls] = useState({});
  const [detailsVisible, setDetailsVisible] = useState(false); // State to toggle details

  const resolveDocumentUrl = useCallback(
    async (path, bucket, isPublic = false) => {
      if (!path) return null;

      const rel = getRelativePath(path, bucket);
      if (!rel) return null;

      try {
        if (isPublic) {
          const { data } = supabase.storage.from(bucket).getPublicUrl(rel);
          return data?.publicUrl;
        }

        const { data, error } = await supabase.storage
          .from(bucket)
          .createSignedUrl(rel, 3600);

        if (error) throw error;
        return data?.signedUrl ?? null;
      } catch (err) {
        console.warn(`Falha na assinatura em ${bucket}/${rel}:`, err.message);
        return null;
      }
    },
    [],
  );

  const generateSignedUrls = useCallback(async () => {
    const docData =
      typeof baba.documentos_url === "string"
        ? (JSON.parse(baba.documentos_url) || {})
        : baba.documentos_url || {};

    const getPath = (field, bucket) => {
      const val = docData[field] || baba[field]; // Tenta no JSON ou na coluna direta (caso babá)
      const raw = val && typeof val === "object" ? val.path : val;
      return getRelativePath(raw, bucket);
    };

    const newUrls = {};

    const frentePath =
      getPath("frente", BUCKET_FRENTE_DOC) ||
      getPath("doc_frente_url", BUCKET_FRENTE_DOC);
    const versoPath =
      getPath("verso", BUCKET_VERSO_DOC) ||
      getPath("doc_verso_url", BUCKET_VERSO_DOC);
    const selfiePath =
      getPath("selfie", BUCKET_SELFIE_DOC) ||
      getPath("doc_selfie_url", BUCKET_SELFIE_DOC);

    try {
      const { data: edgeData, error: edgeError } =
        await supabase.functions.invoke("storage-links", {
          body: { frentePath, versoPath, selfiePath, expiresIn: 3600 },
        });

      if (edgeError) throw edgeError;

      newUrls.frente = edgeData?.frenteUrl || "Documento não enviado";
      newUrls.verso = edgeData?.versoUrl || "Documento não enviado";
      newUrls.selfie = edgeData?.selfieUrl || "Documento não enviado";
    } catch (err) {
      console.warn("Edge Function indisponível, usando fallback direto:", err.message);
      const sign = async (path, bucket) => {
        if (!path) return "Documento não enviado";
        const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 3600);
        return error ? "Erro ao carregar" : (data?.signedUrl ?? "Documento não enviado");
      };
      newUrls.frente = await sign(frentePath, BUCKET_FRENTE_DOC);
      newUrls.verso = await sign(versoPath, BUCKET_VERSO_DOC);
      newUrls.selfie = await sign(selfiePath, BUCKET_SELFIE_DOC);
    }

    // Itens fora da Edge Function continuam manuais
    newUrls.criminal =
      (await resolveDocumentUrl(
        getPath("criminal", BUCKET_DOCUMENTOS),
        BUCKET_DOCUMENTOS,
        false,
      )) || "Não enviado";
    newUrls.foto =
      (await resolveDocumentUrl(baba.foto_url, BUCKET_FOTO_BABAS, true)) ||
      PLACEHOLDER_URL;

    // NEW: Generate URLs for certificates
    const certs = baba.certificados_docs || [];
    const certUrls = await Promise.all(
      certs.map(async (cert) => {
        const cleanPath = getRelativePath(cert?.url, BUCKET_DOCUMENTOS);
        if (!cleanPath)
          return { ...cert, signedUrl: "#", name: cert.name || "Certificado" };

        const relativePath = cleanPath;
        if (relativePath) {
          const { data, error } = await supabase.storage
            .from(BUCKET_DOCUMENTOS)
            .createSignedUrl(relativePath, 300);
          if (error) {
            console.error(
              `Erro ao criar URL assinada para certificado ${cert.name} em ${BUCKET_DOCUMENTOS}/${relativePath}:`,
              error,
            );
            return { ...cert, signedUrl: "#" };
          }
          return { ...cert, signedUrl: data?.signedUrl || "#" };
        }
        return { ...cert, signedUrl: "#" };
      }),
    );
    newUrls.certificados = certUrls;
    setDocumentUrls(newUrls);
  }, [baba, resolveDocumentUrl]);

  const handleFileUpload = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setLoading(true);

      if (type === "perfil") {
        // Upload direto via Supabase client — RLS permite admins em qualquer caminho do bucket
        const ext = (file.name.split(".").pop() || "webp").toLowerCase();
        const fileName = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
        const filePath = `${baba.id}/baba/${fileName}`;

        const { error: uploadError } = await supabase.storage
          .from(BUCKET_FOTO_BABAS)
          .upload(filePath, file, { upsert: true, contentType: file.type || "image/webp" });
        if (uploadError) throw uploadError;

        const { error: updateError } = await supabase
          .from("usuarios")
          .update({ foto_url: filePath })
          .eq("id", baba.id);
        if (updateError) throw updateError;
      } else {
        const folderMap = {
          frente: BUCKET_FRENTE_DOC,
          verso: BUCKET_VERSO_DOC,
          selfie: BUCKET_SELFIE_DOC,
          criminal: BUCKET_DOCUMENTOS,
        };
        const { path, error: uploadError } = await uploadToStorage(
          file,
          folderMap[type],
        );
        if (uploadError) throw new Error(uploadError);
        // Atualiza o objeto JSONB documentos_url na tabela usuarios
        const currentDocs =
          typeof baba.documentos_url === "string"
            ? (JSON.parse(baba.documentos_url) || {})
            : baba.documentos_url || {};

        const newDocs = {
          ...currentDocs,
          [type]: { path: path },
        };

        const { error: updateError } = await supabase
          .from("usuarios")
          .update({ documentos_url: newDocs })
          .eq("id", baba.id);

        if (updateError) throw updateError;
      }

      alert("Imagem atualizada com sucesso!");
      generateSignedUrls();
      if (onStatusChange) onStatusChange(baba.id, baba.doc_status);
    } catch (error) {
      alert("Erro ao salvar: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generateSignedUrls();
  }, [generateSignedUrls]);
  const handleAction = async (newStatus) => {
    setLoading(true);
    try {
      const { error } = await supabase.rpc("rpc_update_doc_status", {
        p_user_id: baba.id,
        p_status: newStatus,
      });
      if (error) throw error;

      // Sincroniza o status de verificação global do usuário
      await supabase.rpc("alterar_verificada_usuarios", {
        p_user_id: baba.id,
        p_verificada: newStatus === "aprovado", // Será 'false' para "reprovado"
      });

      onStatusChange(baba.id, newStatus);
    } catch (error) {
      console.error("Erro ao atualizar status:", error.message);
      console.error(`Erro ao atualizar status: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  const docLinkCls = "text-xs font-medium text-slate-blue-400 hover:underline";

  return (
    <div id={`admin-doc-card-baba-${baba.id}`} className="bg-white rounded-2xl border border-warm-100 shadow-sm p-5 space-y-4">
      <h3 id={`admin-doc-card-title-baba-${baba.id}`} className="text-base font-bold text-warm-900">
        Babysitter: {baba.display_nome || baba.nome} 
      </h3>

      <div id={`admin-doc-card-data-baba-${baba.id}`} className="flex items-center gap-4">
        <div className="relative shrink-0">
          <img
            id={`admin-doc-card-avatar-baba-${baba.id}`}
            src={documentUrls.foto && documentUrls.foto.startsWith("http") ? documentUrls.foto : PLACEHOLDER_URL}
            alt={`Foto de ${baba.nome}`}
            className="h-20 w-20 rounded-full object-cover"
            onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_URL; }}
          />
          <label
            id={`admin-doc-card-avatar-upload-label-baba-${baba.id}`}
            className="absolute bottom-1 right-1 flex items-center justify-center h-7 w-7 rounded-full bg-white shadow-md cursor-pointer"
            title="Alterar Foto de Perfil"
          >
            <Camera size={14} className="text-rose-400" />
            <input id={`admin-doc-card-avatar-upload-input-baba-${baba.id}`} type="file" hidden onChange={(e) => handleFileUpload(e, "perfil")} disabled={loading} />
          </label>
        </div>
        <div id={`admin-doc-card-info-baba-${baba.id}`} className="flex flex-col gap-1 text-sm text-warm-700">
          <p><strong>ID:</strong> {baba.id.substring(0, 8)}...</p>
          <p><strong>Cidade:</strong> {baba.cidade}</p>
          <p><strong>Telefone:</strong> {baba.telefone}</p>
        </div>
      </div>

      <div id={`admin-doc-card-links-baba-${baba.id}`}>
        <h4 className="text-sm font-semibold text-warm-700 mb-2">Documentos Babá</h4>
        <DocumentsViewer user={baba} role="baba" />
      </div>

      <button
        id={`admin-doc-card-btn-details-baba-${baba.id}`}
        className="flex items-center gap-2 text-sm font-medium text-warm-600 hover:text-warm-900 transition-colors"
        onClick={() => setDetailsVisible(!detailsVisible)}
      >
        {detailsVisible ? <EyeOff size={15} /> : <Eye size={15} />}
        {detailsVisible ? "Ocultar Detalhes" : "Ver Perfil Completo"}
      </button>

      {detailsVisible && (
        <div id={`admin-doc-card-details-wrapper-baba-${baba.id}`} className="space-y-4 pt-3 border-t border-warm-100">
          <div className="space-y-1">
            <h4 className="text-sm font-semibold text-warm-700 mb-1">Dados Pessoais</h4>
            <p className="text-sm text-warm-600"><strong>Nome:</strong> {baba.nome} {baba.sobrenome}</p>
            <p className="text-sm text-warm-600"><strong>CPF:</strong> {baba.cpf || "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Nascimento:</strong> {baba.data_nascimento ? new Date(baba.data_nascimento).toLocaleDateString("pt-BR") : "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Endereço:</strong> {`${baba.endereco || ""}, ${baba.numero || "S/N"} - ${baba.bairro || ""}, ${baba.cidade || ""} - ${baba.estado || ""}`}</p>
            {baba.rede_social && (
              <p className="text-sm text-warm-600"><strong>Rede Social:</strong> <a href={baba.rede_social} target="_blank" rel="noopener noreferrer" className={docLinkCls}>{baba.rede_social}</a></p>
            )}
          </div>
          <div className="space-y-1">
            <h4 className="text-sm font-semibold text-warm-700 mb-1">Apresentação e Experiência</h4>
            <p className="text-sm text-warm-600"><strong>Bio:</strong> {baba.bio || "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Experiência:</strong> {baba.experiencia_text || "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Qualificações:</strong> {baba.qualificacoes_text || "Não informado"}</p>
          </div>
          <div className="space-y-1">
            <h4 className="text-sm font-semibold text-warm-700 mb-1">Certificados</h4>
            {documentUrls.certificados && documentUrls.certificados.length > 0 ? (
              <ul className="space-y-1">
                {documentUrls.certificados.map((cert, index) => (
                  <li key={index} className="text-sm text-warm-600">
                    {cert.name}:{" "}
                    {cert.signedUrl !== "#" ? (
                      <a href={cert.signedUrl} target="_blank" rel="noopener noreferrer" className={docLinkCls}>Visualizar</a>
                    ) : (
                      <span className="text-red-400">Link inválido</span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-warm-500">Nenhum certificado enviado.</p>
            )}
          </div>
        </div>
      )}

      <div id={`admin-doc-card-actions-baba-${baba.id}`} className="flex gap-3 pt-3 border-t border-warm-100">
        <button
          id={`admin-doc-card-btn-approve-baba-${baba.id}`}
          className="flex-1 rounded-xl py-2.5 bg-emerald-500 text-white font-semibold text-sm hover:bg-emerald-600 transition-colors disabled:opacity-50"
          onClick={() => handleAction("aprovado")}
          disabled={loading}
        >
          {loading ? "Processando..." : "✅ Aprovar"}
        </button>
        <button
          id={`admin-doc-card-btn-reject-baba-${baba.id}`}
          className="flex-1 rounded-xl py-2.5 bg-red-400 text-white font-semibold text-sm hover:bg-red-500 transition-colors disabled:opacity-50"
          onClick={() => handleAction("reprovado")}
          disabled={loading}
        >
          {loading ? "Processando..." : "❌ Reprovar"}
        </button>
      </div>
    </div>
  );
};

const FamilyVerificationCard = ({ familia, onStatusChange }) => {
  const [loading, setLoading] = useState(false);
  const [documentUrls, setDocumentUrls] = useState({});
  const [detailsVisible, setDetailsVisible] = useState(false);

  const rawDocData = familia[NOME_CAMPO_DB];
  // Memoizado para não recriar a cada render (era dependência instável do
  // useCallback generateSignedUrls, disparando re-fetch a cada render).
  const docData = useMemo(() => {
    if (typeof rawDocData === "string") {
      try {
        return JSON.parse(rawDocData);
      } catch (e) {
        console.error("Erro ao parsear documentos_url da Família como JSON:", e);
        return {};
      }
    }
    if (rawDocData && typeof rawDocData === "object") return rawDocData;
    return {};
  }, [rawDocData]);

  const resolveDocumentUrl = useCallback(
    async (path, bucket, isPublic = false) => {
      if (!path) return null;
      const rel = getRelativePath(path, bucket);
      if (!rel) return null;

      if (isPublic) {
        const { data } = supabase.storage.from(bucket).getPublicUrl(rel);
        return data?.publicUrl;
      }

      const { data, error } = await supabase.storage
        .from(bucket)
        .createSignedUrl(rel, 3600);
      if (error) {
        console.warn(`Falha na assinatura em ${bucket}/${rel}:`, error.message);
        return null;
      }
      return data?.signedUrl ?? null;
    },
    [],
  );

  const generateSignedUrls = useCallback(async () => {
    const getPath = (field, bucket) => {
      const val = docData[field];
      const raw = val && typeof val === "object" ? val.path : val;
      return getRelativePath(raw, bucket);
    };

    const newUrls = {};

    const frentePath = getPath("frente", BUCKET_FRENTE_DOC);
    const versoPath = getPath("verso", BUCKET_VERSO_DOC);
    const selfiePath = getPath("selfie", BUCKET_SELFIE_DOC);

    try {
      const { data: edgeData, error: edgeError } =
        await supabase.functions.invoke("storage-links", {
          body: { frentePath, versoPath, selfiePath, expiresIn: 3600 },
        });

      if (edgeError) throw edgeError;

      newUrls.frente = edgeData?.frenteUrl || "Não enviado";
      newUrls.verso = edgeData?.versoUrl || "Não enviado";
      newUrls.selfie = edgeData?.selfieUrl || "Não enviado";
    } catch (err) {
      console.warn("Edge Function indisponível, usando fallback direto:", err.message);
      const sign = async (path, bucket) => {
        if (!path) return "Não enviado";
        const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 3600);
        return error ? "Erro ao carregar" : (data?.signedUrl ?? "Não enviado");
      };
      newUrls.frente = await sign(frentePath, BUCKET_FRENTE_DOC);
      newUrls.verso = await sign(versoPath, BUCKET_VERSO_DOC);
      newUrls.selfie = await sign(selfiePath, BUCKET_SELFIE_DOC);
    }

    newUrls.criminal =
      (await resolveDocumentUrl(
        getPath("criminal", BUCKET_DOCUMENTOS),
        BUCKET_DOCUMENTOS,
        false,
      )) || "Não enviado";
    newUrls.foto =
      (await resolveDocumentUrl(familia.foto_url, BUCKET_FOTO_FAMILIA, true)) ||
      PLACEHOLDER_URL;

    setDocumentUrls(newUrls);
  }, [docData, familia.foto_url, resolveDocumentUrl]);

  const handleFileUpload = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setLoading(true);
      if (type === "perfil") {
        // Upload direto no bucket correto — evita o bucketMap do uploadToStorage que não conhece os nomes reais dos buckets
        const ext = (file.name.split(".").pop() || "webp").toLowerCase();
        const fileName = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
        const filePath = `${familia.id}/familia/${fileName}`;

        const { error: uploadError } = await supabase.storage
          .from(BUCKET_FOTO_FAMILIA)
          .upload(filePath, file, { upsert: true, contentType: file.type || "image/webp" });
        if (uploadError) throw uploadError;

        const { error: updateError } = await supabase
          .from("usuarios")
          .update({ foto_url: filePath })
          .eq("id", familia.id);
        if (updateError) throw updateError;
      } else {
        const bucketMap = {
          frente: BUCKET_FRENTE_DOC,
          verso: BUCKET_VERSO_DOC,
          selfie: BUCKET_SELFIE_DOC,
          criminal: BUCKET_DOCUMENTOS,
        };
        const { path, error: uploadError } = await uploadToStorage(
          file,
          bucketMap[type] || BUCKET_DOCUMENTO_FAMILIA,
        );
        if (uploadError) throw new Error(uploadError);
        const currentDocs =
          typeof familia[NOME_CAMPO_DB] === "string"
            ? JSON.parse(familia[NOME_CAMPO_DB])
            : familia[NOME_CAMPO_DB] || {};

        const newDocs = { ...currentDocs, [type]: path };

        const { error: updateError } = await supabase
          .from("usuarios_clientes")
          .update({
            [NOME_CAMPO_DB]: newDocs,
          })
          .eq("usuario_id", familia.id);

        if (updateError) throw updateError;
      }

      alert("Imagem atualizada com sucesso!");
      generateSignedUrls();
      if (onStatusChange) onStatusChange(familia.id, familia.doc_status);
    } catch (error) {
      alert("Erro ao salvar: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generateSignedUrls();
  }, [generateSignedUrls]);

  const handleAction = async (newStatus) => {
    setLoading(true);
    try {
      const { error } = await supabase.rpc("rpc_update_doc_status", {
        p_user_id: familia.id,
        p_status: newStatus,
      });

      if (error) throw error;

      onStatusChange(familia.id, newStatus);
      console.log(
        `Perfil de Família ${
          familia.nome
        } marcado como: ${newStatus.toUpperCase()}.`,
      );
    } catch (error) {
      console.error("Erro ao atualizar status:", error.message);
      console.error(`Erro ao atualizar status: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id={`admin-doc-card-fam-${familia.id}`} className="bg-white rounded-2xl border border-warm-100 shadow-sm p-5 space-y-4">
      <h3 id={`admin-doc-card-title-fam-${familia.id}`} className="text-base font-bold text-warm-900">
        Família: {familia.display_nome || familia.nome}
      </h3>

      <div id={`admin-doc-card-data-fam-${familia.id}`} className="flex items-center gap-4">
        <div className="relative shrink-0">
          {documentUrls.foto && documentUrls.foto.startsWith("http") ? (
            <img
              id={`admin-doc-card-avatar-fam-${familia.id}`}
              src={documentUrls.foto}
              alt={`Foto de Perfil de ${familia.nome}`}
              className="h-20 w-20 rounded-full object-cover"
              onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_URL; }}
            />
          ) : (
            <div className="h-20 w-20 rounded-full flex items-center justify-center bg-warm-100">
              <SquareUserRound size={30} className="text-warm-400" />
            </div>
          )}
          <label
            id={`admin-doc-card-avatar-upload-label-fam-${familia.id}`}
            className="absolute bottom-1 right-1 flex items-center justify-center h-7 w-7 rounded-full bg-white shadow-md cursor-pointer"
            title="Alterar Foto de Perfil"
          >
            <Camera size={14} className="text-rose-400" />
            <input id={`admin-doc-card-avatar-upload-input-fam-${familia.id}`} type="file" hidden onChange={(e) => handleFileUpload(e, "perfil")} disabled={loading} />
          </label>
        </div>
        <div id={`admin-doc-card-info-fam-${familia.id}`} className="flex flex-col gap-1 text-sm text-warm-700">
          <p><strong>ID:</strong> {familia.id.substring(0, 8)}...</p>
          <p><strong>Cidade:</strong> {familia.cidade}</p>
          <p><strong>Telefone:</strong> {familia.telefone}</p>
        </div>
      </div>

      <div id={`admin-doc-card-links-fam-${familia.id}`}>
        <h4 className="text-sm font-semibold text-warm-700 mb-2">Documentos Família</h4>
        <DocumentsViewer user={familia} role="familia" />
      </div>

      <button
        id={`admin-doc-card-btn-details-fam-${familia.id}`}
        className="flex items-center gap-2 text-sm font-medium text-warm-600 hover:text-warm-900 transition-colors"
        onClick={() => setDetailsVisible(!detailsVisible)}
      >
        {detailsVisible ? <EyeOff size={15} /> : <Eye size={15} />}
        {detailsVisible ? "Ocultar Detalhes" : "Ver Perfil Completo"}
      </button>

      {detailsVisible && (
        <div className="space-y-4 pt-3 border-t border-warm-100">
          <div className="space-y-1">
            <h4 className="text-sm font-semibold text-warm-700 mb-1">Dados do Responsável</h4>
            <p className="text-sm text-warm-600"><strong>Nome:</strong> {familia.nome} {familia.sobrenome}</p>
            <p className="text-sm text-warm-600"><strong>CPF:</strong> {familia.cpf || "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Nascimento:</strong> {familia.data_nascimento ? new Date(familia.data_nascimento).toLocaleDateString("pt-BR") : "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Endereço:</strong> {`${familia.endereco || ""}, ${familia.numero || "S/N"} - ${familia.bairro || ""}, ${familia.cidade || ""} - ${familia.estado || ""}`}</p>
          </div>
          <div className="space-y-1">
            <h4 className="text-sm font-semibold text-warm-700 mb-1">Sobre as Crianças</h4>
            <p className="text-sm text-warm-600"><strong>Número de Crianças:</strong> {familia.num_criancas || "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Faixa Etária:</strong> {familia.faixa_etaria_preferida?.join(", ") || "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Características e Rotina:</strong> {familia.caracteristicas_crianca || "Não informado"}</p>
            <p className="text-sm text-warm-600"><strong>Necessidades Especiais:</strong> {familia.necessidades_especiais ? "Sim" : "Não"}</p>
            {familia.necessidades_especiais && (
              <p className="text-sm text-warm-600"><strong>Descrição:</strong> {familia.descricao_necessidades || "Não informado"}</p>
            )}
          </div>
          <div className="space-y-1">
            <h4 className="text-sm font-semibold text-warm-700 mb-1">Preferências de Serviço</h4>
            <p className="text-sm text-warm-600"><strong>Frequência:</strong> {familia.frequencia_servico || "Não informado"}</p>
          </div>
          <div className="space-y-1">
            <h4 className="text-sm font-semibold text-warm-700 mb-1">Bio da Família</h4>
            <p className="text-sm text-warm-600">{familia.bio || "Não informado"}</p>
          </div>
        </div>
      )}

      <div className="flex gap-3 pt-3 border-t border-warm-100">
        <button
          className="flex-1 rounded-xl py-2.5 bg-emerald-500 text-white font-semibold text-sm hover:bg-emerald-600 transition-colors disabled:opacity-50"
          onClick={() => handleAction("aprovado")}
          disabled={loading}
        >
          {loading ? "Processando..." : "✅ Aprovar"}
        </button>
        <button
          className="flex-1 rounded-xl py-2.5 bg-red-400 text-white font-semibold text-sm hover:bg-red-500 transition-colors disabled:opacity-50"
          onClick={() => handleAction("reprovado")}
          disabled={loading}
        >
          {loading ? "Processando..." : "❌ Reprovar"}
        </button>
      </div>
    </div>
  );
};
// ====================================================
// CONFIRMAÇÃO DE EXCLUSÃO (substitui window.confirm nas listas de Cadastros)
// ====================================================
const DeleteUserAlert = ({ onConfirm, description, idPrefix }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <ShadButton
        id={idPrefix && `${idPrefix}-btn-delete`}
        variant="ghost"
        size="icon"
        title="Excluir permanentemente"
        className="text-red-400 hover:bg-red-50 hover:text-red-500"
      >
        <Trash2 size={17} />
      </ShadButton>
    </AlertDialogTrigger>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Excluir usuário permanentemente?</AlertDialogTitle>
        <AlertDialogDescription>
          {description || "Todos os dados deste usuário serão apagados definitivamente (perfil, documentos, fotos e login). Esta ação NÃO pode ser desfeita. Para apenas suspender o acesso mantendo os dados, use o botão de ativar/desativar."}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancelar</AlertDialogCancel>
        <AlertDialogAction variant="destructive" onClick={onConfirm}>
          Excluir definitivamente
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

// ====================================================
// LIST ITEM PARA ASSINATURAS E VENDAS (HISTÓRICO)
// ====================================================
const SubscriptionCardListItem = ({ assinatura, onEdit, onDelete }) => {
  const isExpired = (dateString) => {
    if (!dateString) return false;
    return new Date(dateString) < new Date();
  };

  const getStatusInfo = () => {
    if (assinatura.ativa) {
      if (isExpired(assinatura.data_fim))
        return { text: "Expirada", color: "#f59e0b" };
      return { text: "Ativa", color: "#10b981" };
    }
    return { text: assinatura.status_pagamento || "Inativa", color: "#ef4444" };
  };

  const status = getStatusInfo();

  return (
    <div id={`admin-sub-card-item-${assinatura.id}`} className="flex items-center gap-3 bg-white rounded-xl p-3 shadow-sm border border-warm-100">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-warm-100">
        <User size={22} className="text-warm-500" />
      </div>
      <div className="flex-2 min-w-0">
        <p className="font-semibold text-sm text-warm-800 truncate">{assinatura.usuario_nome} {assinatura.usuario_sobrenome}</p>
        <p className="text-xs text-warm-500 truncate">{assinatura.produto_nome}</p>
      </div>
      <div className="flex-2 hidden sm:flex flex-col gap-0.5 text-[11px] text-warm-500">
        <span>Início: {assinatura.data_inicio ? new Date(assinatura.data_inicio).toLocaleDateString() : "-"}</span>
        <span>Fim: {assinatura.data_fim ? new Date(assinatura.data_fim).toLocaleDateString() : "-"}</span>
        <span className="font-semibold" style={{ color: status.color }}>{status.text}</span>
      </div>
      <div className="flex items-center gap-2">
        <button id={`admin-sub-card-btn-edit-${assinatura.id}`} onClick={() => onEdit(assinatura)} title="Editar" className="flex items-center justify-center h-8 w-8 rounded-lg text-slate-blue-400 hover:bg-slate-blue-400/10 transition">
          <Edit size={16} />
        </button>
        <button id={`admin-sub-card-btn-delete-${assinatura.id}`} onClick={() => onDelete(assinatura.id)} title="Excluir" className="flex items-center justify-center h-8 w-8 rounded-lg text-red-400 hover:bg-red-50 transition">
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
};

// ====================================================
// LIST ITEM PARA PLANOS DE ASSINATURA (CATÁLOGO)
// ====================================================
const SubscriptionPlanCardListItem = ({
  plano,
  onEdit,
  onDelete,
  onToggleStatus,
}) => {
  return (
    <div id={`admin-plan-card-item-${plano.id}`} className="flex items-center gap-3 bg-white rounded-xl p-3 shadow-sm border border-warm-100">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-warm-100">
        <Shield size={22} className="text-warm-500" />
      </div>
      <div className="flex-2 min-w-0">
        <p className="font-semibold text-sm text-warm-800 truncate">{plano.nome}</p>
        <p className="text-xs text-warm-500">{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(plano.valor || 0)} /mês</p>
      </div>
      <div className="flex-1 hidden sm:flex">
        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${plano.ativo ? "bg-emerald-100 text-emerald-700" : "bg-warm-100 text-warm-500"}`}>
          {plano.ativo ? "Ativo" : "Inativo"}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <button id={`admin-plan-card-btn-toggle-${plano.id}`} onClick={() => onToggleStatus(plano.id, !plano.ativo)} title={plano.ativo ? "Desativar" : "Ativar"} className={`flex items-center justify-center h-8 w-8 rounded-lg transition ${plano.ativo ? "text-red-400 hover:bg-red-50" : "text-emerald-500 hover:bg-emerald-50"}`}>
          {plano.ativo ? <XCircle size={16} /> : <CheckCircle size={16} />}
        </button>
        <button id={`admin-plan-card-btn-edit-${plano.id}`} onClick={() => onEdit(plano)} title="Editar" className="flex items-center justify-center h-8 w-8 rounded-lg text-slate-blue-400 hover:bg-slate-blue-400/10 transition">
          <Edit size={16} />
        </button>
        <button id={`admin-plan-card-btn-delete-${plano.id}`} onClick={() => onDelete(plano.id)} title="Excluir" className="flex items-center justify-center h-8 w-8 rounded-lg text-red-400 hover:bg-red-50 transition">
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
};

// ====================================================
// LIST ITEM PARA PACOTES DE HORAS (CATÁLOGO)
// ====================================================
const PackageCardListItem = ({ pacote, onEdit, onDelete, onToggleStatus }) => {
  return (
    <div id={`admin-pkg-card-item-${pacote.id}`} className="flex items-center gap-3 bg-white rounded-xl p-3 shadow-sm border border-warm-100">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-warm-100">
        <Package size={22} className="text-warm-500" />
      </div>
      <div className="flex-2 min-w-0">
        <p className="font-semibold text-sm text-warm-800 truncate">{pacote.nome}</p>
        <p className="text-xs text-warm-500">{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(pacote.valor || 0)}{pacote.horas ? ` • ${pacote.horas} horas` : ""}</p>
      </div>
      <div className="flex-1 hidden sm:flex">
        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${pacote.ativo ? "bg-emerald-100 text-emerald-700" : "bg-warm-100 text-warm-500"}`}>
          {pacote.ativo ? "Ativo" : "Inativo"}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <button id={`admin-pkg-card-btn-toggle-${pacote.id}`} onClick={() => onToggleStatus(pacote.id, !pacote.ativo)} title={pacote.ativo ? "Desativar" : "Ativar"} className={`flex items-center justify-center h-8 w-8 rounded-lg transition ${pacote.ativo ? "text-red-400 hover:bg-red-50" : "text-emerald-500 hover:bg-emerald-50"}`}>
          {pacote.ativo ? <XCircle size={16} /> : <CheckCircle size={16} />}
        </button>
        <button id={`admin-pkg-card-btn-edit-${pacote.id}`} onClick={() => onEdit(pacote)} title="Editar" className="flex items-center justify-center h-8 w-8 rounded-lg text-slate-blue-400 hover:bg-slate-blue-400/10 transition">
          <Edit size={16} />
        </button>
        <button id={`admin-pkg-card-btn-delete-${pacote.id}`} onClick={() => onDelete(pacote.id)} title="Excluir" className="flex items-center justify-center h-8 w-8 rounded-lg text-red-400 hover:bg-red-50 transition">
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
};

// ====================================================
// TABELA DE USUÁRIOS (data table shadcn + seleção em massa)
// Substitui os cards por linhas. Serve às 3 sub-listas (aprovações,
// incompletos, ativos) para babás e famílias.
// ====================================================
const isFamiliaUser = (u) => u.tipo === "cliente" || u.tipo === "familia";

const resolveUserPhoto = (u) => {
  if (isFamiliaUser(u)) {
    const p = u.foto_url;
    if (!p) return PLACEHOLDER_URL;
    if (p.startsWith("http")) return p;
    const rel = getRelativePath(p, BUCKET_FOTO_FAMILIA);
    return rel
      ? supabase.storage.from(BUCKET_FOTO_FAMILIA).getPublicUrl(rel).data?.publicUrl
      : PLACEHOLDER_URL;
  }
  return getBabaPhotoCandidates(u.foto_url)[0] || PLACEHOLDER_URL;
};

const StatusPill = ({ user, variant }) => {
  if (variant === "aprovacoes") {
    const map = {
      enviado: { label: "Enviado", cls: "border-amber-200 bg-amber-100 text-amber-700" },
      reprovado: { label: "Reprovado", cls: "border-red-200 bg-red-100 text-red-700" },
      aprovado: { label: "Aprovado", cls: "border-emerald-200 bg-emerald-100 text-emerald-700" },
    };
    const cfg = map[user.doc_status] || map.enviado;
    return (
      <span className={cn("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium", cfg.cls)}>
        <Clock size={11} /> {cfg.label}
      </span>
    );
  }
  if (variant === "incompletos") {
    return (
      <span className="inline-flex items-center rounded-full border border-warm-200 bg-warm-50 px-2 py-0.5 text-xs font-medium text-warm-600">
        Incompleto
      </span>
    );
  }
  const inactive = user.status_conta === false;
  return (
    <span className={cn(
      "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium",
      inactive ? "border-border bg-muted text-muted-foreground" : "border-emerald-200 bg-emerald-100 text-emerald-700",
    )}>
      <span className={cn("size-1.5 rounded-full", inactive ? "bg-muted-foreground" : "bg-emerald-500")} />
      {inactive ? "Inativo" : "Ativo"}
    </span>
  );
};

const UsersTable = ({
  users = [],
  variant = "todos",
  onView,
  onEdit,
  onToggleActive,
  onDelete,
  onBulkDelete,
  onBulkToggle,
  emptyMessage,
}) => {
  const [selected, setSelected] = useState(() => new Set());

  // Mantém a seleção coerente quando a lista muda (busca, refresh, exclusão).
  useEffect(() => {
    setSelected((prev) => {
      if (prev.size === 0) return prev;
      const ids = new Set(users.map((u) => u.id));
      const next = new Set();
      prev.forEach((id) => ids.has(id) && next.add(id));
      return next.size === prev.size ? prev : next;
    });
  }, [users]);

  const allSelected = users.length > 0 && selected.size === users.length;
  const someSelected = selected.size > 0 && !allSelected;
  const clear = () => setSelected(new Set());
  const toggleAll = () =>
    setSelected(allSelected ? new Set() : new Set(users.map((u) => u.id)));
  const toggleOne = (id) =>
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const onPhotoErr = (e, u) => {
    if (isFamiliaUser(u)) {
      e.target.onerror = null;
      e.target.src = PLACEHOLDER_URL;
    } else {
      handleBabaPhotoError(e, getBabaPhotoCandidates(u.foto_url));
    }
  };

  const detailHeader = variant === "incompletos" ? "Pendências" : "Cidade";
  const detailCell = (u) => {
    if (variant === "incompletos") {
      const miss = [...(u.pendencias?.babas || []), ...(u.pendencias?.clientes || [])];
      return (
        <span className="text-xs text-muted-foreground">
          {miss.length ? `${miss.length} campo${miss.length > 1 ? "s" : ""} faltando` : "—"}
        </span>
      );
    }
    return <span className="text-sm text-muted-foreground">{u.cidade || "—"}</span>;
  };

  if (!users.length) {
    return (
      <div className="rounded-[3px] border border-dashed border-border bg-card py-10 text-center text-sm text-muted-foreground">
        {emptyMessage || "Nenhum registro."}
      </div>
    );
  }

  const selectedIds = () => Array.from(selected);

  return (
    <div className="space-y-3">
      {selected.size > 0 && (
        <div className="flex flex-wrap items-center gap-2 rounded-[3px] border border-primary/20 bg-primary/5 px-3 py-2">
          <span className="text-sm font-semibold text-foreground">
            {selected.size} selecionado{selected.size > 1 ? "s" : ""}
          </span>
          <div className="ml-auto flex flex-wrap items-center gap-2">
            <ShadButton size="sm" variant="outline" onClick={() => { onBulkToggle?.(selectedIds(), true); clear(); }}>
              <CheckCircle size={14} /> Ativar
            </ShadButton>
            <ShadButton size="sm" variant="outline" onClick={() => { onBulkToggle?.(selectedIds(), false); clear(); }}>
              <XCircle size={14} /> Desativar
            </ShadButton>
            <AlertDialog>
              <AlertDialogTrigger asChild>
                <ShadButton size="sm" variant="destructive">
                  <Trash size={14} /> Excluir
                </ShadButton>
              </AlertDialogTrigger>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>
                    Excluir {selected.size} usuário{selected.size > 1 ? "s" : ""} permanentemente?
                  </AlertDialogTitle>
                  <AlertDialogDescription>
                    Todos os dados desses usuários (perfil, documentos, fotos e login) serão apagados definitivamente. Esta ação não pode ser desfeita.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel>Cancelar</AlertDialogCancel>
                  <AlertDialogAction variant="destructive" onClick={() => { onBulkDelete?.(selectedIds()); clear(); }}>
                    Excluir definitivamente
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
            <ShadButton size="sm" variant="ghost" onClick={clear}>Limpar</ShadButton>
          </div>
        </div>
      )}

      <div className="overflow-x-auto rounded-[3px] border border-border bg-card">
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead className="w-10">
                <Checkbox
                  checked={allSelected ? true : someSelected ? "indeterminate" : false}
                  onCheckedChange={toggleAll}
                  aria-label="Selecionar todos"
                />
              </TableHead>
              <TableHead>Nome</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>{detailHeader}</TableHead>
              <TableHead className="pr-4 text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((u) => {
              const isSel = selected.has(u.id);
              return (
                <TableRow key={u.id} data-state={isSel ? "selected" : undefined} className={cn(isSel && "bg-primary/5")}>
                  <TableCell>
                    <Checkbox checked={isSel} onCheckedChange={() => toggleOne(u.id)} aria-label={`Selecionar ${u.nome || u.email}`} />
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-3">
                      <img
                        src={resolveUserPhoto(u)}
                        onError={(e) => onPhotoErr(e, u)}
                        alt=""
                        className="h-9 w-9 shrink-0 rounded-full object-cover"
                      />
                      <div className="min-w-0">
                        <div className="truncate text-sm font-medium text-foreground">
                          {u.display_nome || u.nome || u.email || "Sem nome"}
                        </div>
                        {u.email && (u.nome || u.display_nome) && (
                          <div className="truncate text-xs text-muted-foreground">{u.email}</div>
                        )}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell><StatusPill user={u} variant={variant} /></TableCell>
                  <TableCell>{detailCell(u)}</TableCell>
                  <TableCell className="pr-3">
                    <div className="flex items-center justify-end gap-0.5">
                      <ShadButton
                        variant="ghost"
                        size="icon"
                        className="size-8 text-primary hover:bg-primary/10"
                        title={variant === "aprovacoes" ? "Verificar documentos" : "Visualizar"}
                        onClick={() => onView?.(u)}
                      >
                        {variant === "aprovacoes" ? <FileText size={16} /> : <Eye size={16} />}
                      </ShadButton>
                      <ShadButton
                        variant="ghost"
                        size="icon"
                        className="size-8 text-secondary hover:bg-secondary/10"
                        title="Editar cadastro"
                        onClick={() => onEdit?.(u)}
                      >
                        <Edit size={16} />
                      </ShadButton>
                      <ShadButton
                        variant="ghost"
                        size="icon"
                        className={cn(
                          "size-8",
                          u.status_conta === false
                            ? "text-emerald-500 hover:bg-emerald-50"
                            : "text-amber-500 hover:bg-amber-50",
                        )}
                        title={u.status_conta === false ? "Ativar conta" : "Desativar conta"}
                        onClick={() => onToggleActive?.(u.id, u.status_conta)}
                      >
                        {u.status_conta === false ? <CheckCircle size={16} /> : <XCircle size={16} />}
                      </ShadButton>
                      <DeleteUserAlert
                        idPrefix={`admin-table-${u.id}`}
                        onConfirm={() => onDelete?.(u.id)}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

// ----------------------------------------------------
// NOVO: Conteúdo unificado de VERIFICAÇÕES
// ----------------------------------------------------

const VerificacoesContent = ({
  loading,
  babasPendentes,
  familiasPendentes,
  incompleteUsers,
  registeredUsers,
  handleStatusUpdate,
  handleDeleteIncompleteUser,
  handleDeleteRegisteredUser,
  handleToggleUserStatus,
  handleBulkDelete,
  handleBulkToggle,
  fetchRegisteredUsers,
  fetchIncompleteUsers,
  initialTab,
}) => {
  const navigate = useNavigate();
  const [userParaEditar, setUserParaEditar] = useState(null);
  const [userParaVerificar, setUserParaVerificar] = useState(null);
  const [photoLoading, setPhotoLoading] = useState(false);
  const [search, setSearch] = useState("");

  // Ao abrir o modal de verificação/aprovação, busca o usuário COMPLETO em
  // `usuarios` (com documentos_url/foto_url). A lista de Incompletos vem de
  // usuarios_pendentes_detalhado, que não retorna documentos_url — sem isso os
  // documentos apareciam como "Faltando" mesmo enviados.
  const handleView = useCallback(async (u) => {
    const id = u?.id || u?.usuario_id;
    if (!id) return setUserParaVerificar(u);
    setUserParaVerificar(u); // abre imediatamente com o que já temos
    const { data } = await supabase
      .from("usuarios")
      .select("*")
      .eq("id", id)
      .maybeSingle();
    if (data) setUserParaVerificar((prev) => (prev ? { ...prev, ...data } : prev));
  }, []);

  // Deriva view e subTab do initialTab externo
  const initial = parseInitialCadastrosTab(initialTab);
  const [view, setView]   = useState(initial.view);   // "overview" | "babas" | "familias"
  const [subTab, setSubTab] = useState(initial.sub);  // "aprovacoes" | "incompletos" | "todos"

  const handleAdminPhotoUpload = async (e, user) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      setPhotoLoading(true);
      const isFamilia = user.tipo === "cliente" || user.tipo === "familia";
      const bucket = isFamilia ? BUCKET_FOTO_FAMILIA : BUCKET_FOTO_BABAS;
      const ext = (file.name.split(".").pop() || "webp").toLowerCase();
      const fileName = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
      const subFolder = isFamilia ? "familia" : "baba";
      const filePath = `${user.id}/${subFolder}/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from(bucket)
        .upload(filePath, file, { upsert: true, contentType: file.type || "image/webp" });
      if (uploadError) throw uploadError;

      const { error: updateError } = await supabase
        .from("usuarios")
        .update({ foto_url: filePath })
        .eq("id", user.id);
      if (updateError) throw updateError;

      alert("Foto atualizada com sucesso!");
      setUserParaEditar((prev) => ({ ...prev, foto_url: filePath }));
      fetchRegisteredUsers?.();
      fetchIncompleteUsers?.();
    } catch (error) {
      alert("Erro ao salvar foto: " + error.message);
    } finally {
      setPhotoLoading(false);
    }
  };

  const goTo = (nextView, nextSub = "aprovacoes") => {
    setView(nextView);
    setSubTab(nextSub);
    setSearch("");
  };

  // ── KPI ──────────────────────────────────────────────────
  // Derivação pura testada em ./dashboardAdminKpi.test.js — não recalcular
  // inline aqui (foi a causa de uma regressão de bug anterior).
  const kpi = computeCadastrosKpi({
    registeredUsers,
    babasPendentes,
    familiasPendentes,
    incompleteUsers,
  });

  // ══════════════════════════════════════════════════════════
  // OVERVIEW
  // ══════════════════════════════════════════════════════════
  if (view === "overview") {
    const OverviewCard = ({ tipo, label, k }) => (
      <Card>
        <CardHeader className="flex-row items-center justify-between">
          <CardTitle className="text-lg">{label}</CardTitle>
          <span className="text-3xl font-extrabold text-primary">{k.total}</span>
        </CardHeader>
        <CardContent className="flex flex-col gap-5">
          <div className="grid grid-cols-3 gap-3">
            <div className="rounded-xl bg-muted p-3 text-center">
              <p className="text-xl font-bold text-emerald-600">{k.ativos}</p>
              <p className="mt-0.5 text-[10px] font-semibold text-muted-foreground">Ativos</p>
            </div>
            <div className="rounded-xl bg-muted p-3 text-center">
              <p className="text-xl font-bold text-amber-500">{k.pendentesDoc}</p>
              <p className="mt-0.5 text-[10px] font-semibold text-muted-foreground">Em análise</p>
            </div>
            <div className="rounded-xl bg-muted p-3 text-center">
              <p className="text-xl font-bold text-muted-foreground">{k.incompletos}</p>
              <p className="mt-0.5 text-[10px] font-semibold text-muted-foreground">Incompletos</p>
            </div>
          </div>

          <div className="flex gap-2">
            <ShadButton className="flex-1" onClick={() => goTo(tipo, "todos")}>
              Ver {label} →
            </ShadButton>
            {k.pendentesDoc > 0 && (
              <ShadButton variant="outline" onClick={() => goTo(tipo, "aprovacoes")}>
                <Badge variant="secondary">{k.pendentesDoc}</Badge>
                pendente{k.pendentesDoc > 1 ? "s" : ""}
              </ShadButton>
            )}
          </div>
        </CardContent>
      </Card>
    );

    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-bold text-foreground">Cadastros</h1>
          <div className="flex gap-2">
            <ShadButton onClick={() => navigate("/cadastro-baba")}>
              <Plus size={15} /> Babá
            </ShadButton>
            <ShadButton variant="secondary" onClick={() => navigate("/cadastro-familia")}>
              <Plus size={15} /> Família
            </ShadButton>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <OverviewCard tipo="babas" label="Babás" k={kpi.babas} />
          <OverviewCard tipo="familias" label="Famílias" k={kpi.familias} />
        </div>
      </div>
    );
  }

  // ══════════════════════════════════════════════════════════
  // PÁGINA DEDICADA (BABAS ou FAMILIAS)
  // ══════════════════════════════════════════════════════════
  const isBabas   = view === "babas";
  const typeLabel = isBabas ? "Babás" : "Famílias";
  const k         = isBabas ? kpi.babas : kpi.familias;
  const typeFilter = isBabas ? isBaba : isFamilia;

  // Listas filtradas por busca
  const q = search.toLowerCase();
  const filterUser = (u) => !q || (u.nome || "").toLowerCase().includes(q) || (u.email || "").toLowerCase().includes(q);

  const pendentesLista = isBabas ? babasPendentes : familiasPendentes;
  const incompletosLista = (incompleteUsers || []).filter((u) => typeFilter(u) && (isBabas ? u.pendencias?.babas?.length > 0 : u.pendencias?.clientes?.length > 0));
  const todosLista = (registeredUsers || []).filter(typeFilter);
  const filteredPendentes = pendentesLista.filter(filterUser);
  const filteredIncompletos = incompletosLista.filter(filterUser);
  const filteredTodos = todosLista.filter(filterUser);

  const tabDescription = {
    aprovacoes: "Perfis com documentos enviados aguardando análise.",
    incompletos: "Perfis com campos obrigatórios faltando para concluir o cadastro.",
    todos: "Perfis ativos e completos para gestão diária do admin.",
  };

  const tabCount = {
    aprovacoes: filteredPendentes.length,
    incompletos: filteredIncompletos.length,
    todos: filteredTodos.length,
  };

  return (
    <div className="space-y-5">
      {/* HEADER */}
      <div className="flex items-center gap-3">
        <ShadButton variant="outline" size="icon" onClick={() => setView("overview")}>
          ←
        </ShadButton>
        <h1 className="text-xl font-bold text-foreground">{typeLabel}</h1>
        <ShadButton
          className="ml-auto"
          variant={isBabas ? "default" : "secondary"}
          onClick={() => navigate(isBabas ? "/cadastro-baba" : "/cadastro-familia")}
        >
          <Plus size={15} /> Cadastrar {isBabas ? "Babá" : "Família"}
        </ShadButton>
      </div>

      {/* KPI STRIP */}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Card className="cursor-pointer items-center py-4" onClick={() => setSubTab("todos")}>
          <CardContent className="flex flex-col items-center p-0">
            <span className="text-2xl font-extrabold">{k.total}</span>
            <span className="mt-0.5 text-xs font-medium text-muted-foreground">Total</span>
          </CardContent>
        </Card>
        <Card className="cursor-pointer items-center border-emerald-100 bg-emerald-50 py-4" onClick={() => setSubTab("todos")}>
          <CardContent className="flex flex-col items-center p-0">
            <span className="text-2xl font-extrabold text-emerald-700">{k.ativos}</span>
            <span className="mt-0.5 text-xs font-medium text-emerald-700/80">Ativos</span>
          </CardContent>
        </Card>
        <Card className="cursor-pointer items-center border-amber-100 bg-amber-50 py-4" onClick={() => setSubTab("aprovacoes")}>
          <CardContent className="flex flex-col items-center p-0">
            <span className="text-2xl font-extrabold text-amber-700">{k.pendentesDoc}</span>
            <span className="mt-0.5 text-xs font-medium text-amber-700/80">Em análise</span>
          </CardContent>
        </Card>
        <Card className="cursor-pointer items-center bg-muted py-4" onClick={() => setSubTab("incompletos")}>
          <CardContent className="flex flex-col items-center p-0">
            <span className="text-2xl font-extrabold text-muted-foreground">{k.incompletos}</span>
            <span className="mt-0.5 text-xs font-medium text-muted-foreground">Incompletos</span>
          </CardContent>
        </Card>
      </div>

      {/* SUB-TABS + BUSCA */}
      <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
        <Tabs value={subTab} onValueChange={setSubTab}>
          <TabsList>
            <TabsTrigger value="aprovacoes">
              Aprovações
              {k.pendentesDoc > 0 && <Badge variant="secondary">{k.pendentesDoc}</Badge>}
            </TabsTrigger>
            <TabsTrigger value="incompletos">
              Incompletos
              {k.incompletos > 0 && <Badge variant="secondary">{k.incompletos}</Badge>}
            </TabsTrigger>
            <TabsTrigger value="todos">
              Ativos
              {k.ativos > 0 && <Badge variant="secondary">{k.ativos}</Badge>}
            </TabsTrigger>
          </TabsList>
        </Tabs>
        <div className="relative sm:ml-auto">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <ShadInput
            type="text"
            placeholder="Buscar por nome ou email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-60 pl-8"
          />
        </div>
      </div>

      <div className="rounded-xl border border-border bg-card px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
        <span className="text-sm font-semibold text-foreground">
          {subTab === "aprovacoes"
            ? "Aprovações"
            : subTab === "incompletos"
              ? "Incompletos"
              : "Ativos"}
          {": "}
          <span className="text-primary">{tabCount[subTab] || 0}</span>
        </span>
        <span className="text-xs text-warm-500">{tabDescription[subTab]}</span>
        {search && (
          <button
            type="button"
            className="sm:ml-auto rounded-lg border border-warm-200 px-3 py-1.5 text-xs font-semibold text-warm-600 hover:bg-warm-50 transition"
            onClick={() => setSearch("")}
          >
            Limpar busca
          </button>
        )}
      </div>

      {/* CONTEÚDO DA SUB-TAB */}
      {loading && <p className="text-sm text-warm-500">Carregando...</p>}

      {!loading && subTab === "aprovacoes" && (
        <UsersTable
          users={filteredPendentes}
          variant="aprovacoes"
          onView={handleView}
          onEdit={setUserParaEditar}
          onToggleActive={handleToggleUserStatus}
          onDelete={handleDeleteRegisteredUser}
          onBulkDelete={handleBulkDelete}
          onBulkToggle={handleBulkToggle}
          emptyMessage={`Nenhuma ${typeLabel.slice(0, -1).toLowerCase()} pendente de aprovação.`}
        />
      )}

      {!loading && subTab === "incompletos" && (
        <UsersTable
          users={filteredIncompletos}
          variant="incompletos"
          onView={handleView}
          onEdit={setUserParaEditar}
          onToggleActive={handleToggleUserStatus}
          onDelete={handleDeleteIncompleteUser}
          onBulkDelete={handleBulkDelete}
          onBulkToggle={handleBulkToggle}
          emptyMessage="Nenhum cadastro incompleto."
        />
      )}

      {!loading && subTab === "todos" && (
        <UsersTable
          users={filteredTodos}
          variant="todos"
          onView={handleView}
          onEdit={setUserParaEditar}
          onToggleActive={handleToggleUserStatus}
          onDelete={handleDeleteRegisteredUser}
          onBulkDelete={handleBulkDelete}
          onBulkToggle={handleBulkToggle}
          emptyMessage="Nenhum cadastro ativo."
        />
      )}

      {/* Modal de Edição */}
      <Dialog open={!!userParaEditar} onOpenChange={(open) => !open && setUserParaEditar(null)}>
        <DialogContent className="w-[95vw] sm:max-w-6xl max-h-[90vh] overflow-y-auto rounded-[3px]">
          <DialogTitle className="sr-only">
            Editando usuário: {userParaEditar?.nome || userParaEditar?.email}
          </DialogTitle>
          {userParaEditar && (
            <div className="p-2 sm:p-4">
              <h2 className="mb-4 text-center text-base font-bold text-primary">
                Editando: {userParaEditar.nome || userParaEditar.email}
              </h2>
              <div className="flex flex-col items-center mb-5 pb-4 border-b border-border">
                <div className="relative">
                  <img
                    src={(() => {
                      const isFamiliaUser = userParaEditar.tipo === "cliente" || userParaEditar.tipo === "familia";
                      if (isFamiliaUser) {
                        const path = userParaEditar.foto_url;
                        if (!path) return PLACEHOLDER_URL;
                        if (path.startsWith("http")) return path;
                        const rel = getRelativePath(path, BUCKET_FOTO_FAMILIA);
                        return rel ? supabase.storage.from(BUCKET_FOTO_FAMILIA).getPublicUrl(rel).data?.publicUrl : PLACEHOLDER_URL;
                      }
                      return getBabaPhotoCandidates(userParaEditar.foto_url)[0];
                    })()}
                    alt="Foto de Perfil"
                    className="h-20 w-20 rounded-full object-cover"
                    onError={(e) => {
                      const isFamiliaUser = userParaEditar.tipo === "cliente" || userParaEditar.tipo === "familia";
                      if (isFamiliaUser) { e.target.onerror = null; e.target.src = PLACEHOLDER_URL; }
                      else handleBabaPhotoError(e, getBabaPhotoCandidates(userParaEditar.foto_url));
                    }}
                  />
                  <label className="absolute bottom-0 right-0 cursor-pointer flex items-center justify-center h-7 w-7 rounded-full bg-white shadow-md border border-border">
                    <Camera size={14} className="text-primary" />
                    <input type="file" hidden onChange={(e) => handleAdminPhotoUpload(e, userParaEditar)} disabled={photoLoading} />
                  </label>
                </div>
                <span className="mt-2 text-xs text-muted-foreground">{photoLoading ? "Enviando..." : "Alterar foto"}</span>
              </div>
              <AdminEditForm
                userId={userParaEditar.id}
                userType={userParaEditar.tipo}
                onClose={() => { setUserParaEditar(null); fetchRegisteredUsers?.(); fetchIncompleteUsers?.(); }}
              />
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de Verificação de Documentos (aba Aprovações) */}
      <Dialog open={!!userParaVerificar} onOpenChange={(open) => !open && setUserParaVerificar(null)}>
        <DialogContent className="w-[95vw] sm:max-w-6xl max-h-[90vh] overflow-y-auto rounded-[3px]">
          <DialogTitle className="sr-only">Verificar documentos</DialogTitle>
          {userParaVerificar &&
            (isFamilia(userParaVerificar) ? (
              <FamilyVerificationCard
                familia={userParaVerificar}
                onStatusChange={() => {
                  handleStatusUpdate();
                  setUserParaVerificar(null);
                }}
              />
            ) : (
              <DocumentVerificationCard
                baba={userParaVerificar}
                onStatusChange={() => {
                  handleStatusUpdate();
                  setUserParaVerificar(null);
                }}
              />
            ))}
        </DialogContent>
      </Dialog>
    </div>
  );
};

// ====================================================
// NOVO: Componente para editar o conteúdo do site
// ====================================================
const ConteudoContent = () => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      const { data, error } = await supabase.from("site_content").select("*");
      if (error) {
        setError("Erro ao carregar conteúdo.");
        console.error(error);
      } else {
        const contentMap = data.reduce((acc, item) => {
          acc[item.key] = item.content;
          return acc;
        }, {});
        setContent(contentMap);
      }
      setLoading(false);
    };
    fetchContent();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContent((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccess(null);

    const updates = Object.keys(content).map((key) => ({
      key,
      content: content[key],
    }));

    const { error: upsertError } = await supabase
      .from("site_content")
      .upsert(updates);

    if (upsertError) {
      setError("Falha ao salvar o conteúdo.");
      console.error(upsertError);
    } else {
      setSuccess("Conteúdo salvo com sucesso!");
      setTimeout(() => setSuccess(null), 3000);
    }
    setSaving(false);
  };

  if (loading) {
    return <p className="text-sm text-muted-foreground">Carregando editor de conteúdo...</p>;
  }

  const taCls = "w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50";

  return (
    <div id="admin-content-editor-wrapper" className="space-y-4">
      <h2 id="admin-content-editor-title" className="text-xl font-bold text-foreground">
        Editar o Sobre Nós
      </h2>

      {error && <div className="rounded-xl bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3">{error}</div>}
      {success && <div className="rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm px-4 py-3">{success}</div>}

      <Card id="admin-content-editor-card">
        <CardContent className="space-y-4 p-5">
          <h3 className="text-base font-semibold text-foreground">Seção "Sobre Nós"</h3>
          <div id="admin-content-editor-field-p1" className="space-y-1">
            <Label>Parágrafo 1</Label>
            <textarea name="sobre_nos_p1" value={content.sobre_nos_p1 || ""} onChange={handleChange} rows={5} className={taCls} />
          </div>
          <div id="admin-content-editor-field-p2" className="space-y-1">
            <Label>Parágrafo 2 (Fundadora)</Label>
            <textarea name="sobre_nos_p2" value={content.sobre_nos_p2 || ""} onChange={handleChange} rows={5} className={taCls} />
          </div>
          <div id="admin-content-editor-field-p3" className="space-y-1">
            <Label>Parágrafo 3 (Encerramento)</Label>
            <textarea name="sobre_nos_p3" value={content.sobre_nos_p3 || ""} onChange={handleChange} rows={2} className={taCls} />
          </div>
          <div id="admin-content-editor-actions">
            <ShadButton id="admin-content-editor-btn-save" onClick={handleSave} disabled={saving}>
              {saving ? "Salvando..." : "Salvar Conteúdo"}
            </ShadButton>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

// ----------------------------------------------------
// Componentes Placeholder (Dashboard, Financeiro, Atualizações)
// ----------------------------------------------------
const DashboardCard = ({ title, value, icon, className, onClick }) => (
  <Card
    className={`${className || ""} ${onClick ? "cursor-pointer hover:brightness-95 transition-[filter]" : ""}`}
    onClick={onClick}
  >
    <CardContent className="flex items-center gap-4 p-4">
      <div className="shrink-0">{icon}</div>
      <div className="min-w-0">
        <p className="text-xs font-medium text-muted-foreground truncate">{title}</p>
        <p className="text-2xl font-bold text-foreground leading-tight">{value}</p>
      </div>
      {onClick && <div className="ml-auto shrink-0 text-muted-foreground">›</div>}
    </CardContent>
  </Card>
);

const SectionHeader = ({ children }) => (
  <div className="flex items-center gap-2 mb-4">
    <span className="h-4 w-1 rounded-full bg-primary" />
    <h3 className="text-xs font-bold text-muted-foreground uppercase tracking-widest">{children}</h3>
  </div>
);

const DashboardContent = ({ metrics, loading, onNavigate }) => {
  if (loading) return (
    <div className="flex items-center justify-center py-20">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
  return (
    <div className="space-y-8">
      {/* Cabeçalho da página */}
      <div className="flex items-start justify-between pb-5 border-b border-border">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Dashboard</h1>
          <p className="text-sm text-muted-foreground mt-1">Visão geral da plataforma Tesourinhos</p>
        </div>
        <Badge variant="outline" className="hidden sm:inline-flex">
          <span className="h-2 w-2 rounded-full bg-emerald-400" />
          Dados ao vivo
        </Badge>
      </div>

      {/* KPIs topo — Cadastros */}
      <div>
        <SectionHeader>Cadastros</SectionHeader>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <DashboardCard title="Babás Ativas" value={metrics.activeBabas} icon={<CheckCircle size={22} className="text-emerald-500" />} className="bg-emerald-50 border-emerald-100" onClick={() => onNavigate("Cadastros", "babas-todos")} />
          <DashboardCard title="Babás em análise" value={metrics.pendingBabas} icon={<Clock size={22} className="text-amber-500" />} className="bg-amber-50 border-amber-100" onClick={() => onNavigate("Cadastros", "babas-aprovacoes")} />
          <DashboardCard title="Famílias Ativas" value={metrics.activeFamilias} icon={<CheckCircle size={22} className="text-sky-500" />} className="bg-sky-50 border-sky-100" onClick={() => onNavigate("Cadastros", "familias-todos")} />
          <DashboardCard title="Famílias em análise" value={metrics.pendingFamilias} icon={<Clock size={22} className="text-orange-400" />} className="bg-orange-50 border-orange-100" onClick={() => onNavigate("Cadastros", "familias-aprovacoes")} />
        </div>
      </div>

      {/* Financeiro + Pacotes */}
      <div>
        <SectionHeader>Financeiro &amp; Pacotes</SectionHeader>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <DashboardCard title="Receita Total (Aprovada)" value={`R$ ${(metrics.totalRevenue || 0).toFixed(2)}`} icon={<Wallet size={22} className="text-emerald-500" />} className="bg-emerald-50 border-emerald-100" />
          <DashboardCard title="Agendamentos Concluídos" value={metrics.agendamentosConcluidos || 0} icon={<Briefcase size={22} className="text-indigo-500" />} className="bg-indigo-50 border-indigo-100" />
          <DashboardCard title="Pacotes Ativos" value={metrics.pacotesAtivos} icon={<Package size={22} className="text-violet-500" />} className="bg-violet-50 border-violet-100" />
        </div>
      </div>

      {/* Totais */}
      <div>
        <SectionHeader>Totais Gerais</SectionHeader>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <DashboardCard title="Total Babás" value={metrics.totalBabas || 0} icon={<Users size={22} className="text-primary" />} className="bg-primary/5 border-primary/20" onClick={() => onNavigate("Cadastros", "babas-todos")} />
          <DashboardCard title="Total Famílias" value={metrics.totalFamilias || 0} icon={<Users size={22} className="text-slate-500" />} className="bg-slate-50 border-slate-100" />
          <DashboardCard title="Total Pacotes" value={metrics.totalPacotes || 0} icon={<Package size={22} className="text-violet-400" />} className="bg-violet-50 border-violet-100" />
          <DashboardCard title="Total Assinaturas" value={metrics.totalAssinaturas || 0} icon={<Shield size={22} className="text-indigo-400" />} className="bg-indigo-50 border-indigo-100" />
        </div>
      </div>
    </div>
  );
};

// ----------------------------------------------------
// Componentes Placeholder (Financeiro, Atualizações)
// ----------------------------------------------------

const AtualizacoesContent = ({ onOpenConteudo }) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col items-center justify-center py-12 text-center gap-4">
        <Settings size={40} className="text-muted-foreground/50" />
        <p className="text-sm text-muted-foreground max-w-sm">
          Outras ferramentas de comunicados e promoções serão adicionadas aqui.
        </p>
        <ShadButton variant="secondary" onClick={onOpenConteudo}>
          <FileEdit size={18} /> Editar Sobre Nós
        </ShadButton>
      </div>
    </div>
  );
};
// ----------------------------------------------------
// Dashboard Admin Principal (Refatorado)
// ----------------------------------------------------
export default function DashboardAdmin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [babasPendentes, setBabasPendentes] = useState([]);
  const [familiasPendentes, setFamiliasPendentes] = useState([]);
  const [incompleteUsers, setIncompleteUsers] = useState([]);
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [dashboardMetrics, setDashboardMetrics] = useState({
    activeBabas: null,
    pendingBabas: null,

    totalBabas: null, // Novo

    activeFamilias: null,
    pendingFamilias: null,
    totalFamilias: null, // Novo

    pacotesAtivos: null,
    totalPacotes: null, // Novo

    assinaturasAtivas: null,
    totalAssinaturas: null,

    totalRevenue: 0, // Novo
  });
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [cadastrosInitialTab, setCadastrosInitialTab] = useState("aprovacoes");
  const [showConteudoModal, setShowConteudoModal] = useState(false);

  // Função para buscar as MÉTRICAS DO DASHBOARD (ATUALIZADA)
  const fetchDashboardMetrics = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from("vw_admin_dashboard_metrics")
        .select("*")
        .single();
      if (error) throw error;

      setDashboardMetrics({
        activeBabas: data.active_babas,
        pendingBabas: data.pending_babas,
        totalBabas: data.total_babas,
        totalFamilias: data.total_familias,
        activeFamilias: data.active_familias,
        pendingFamilias: data.pending_familias,
        pacotesAtivos: data.active_packages,
        totalPacotes: data.total_packages,
        totalRevenue: data.total_revenue,
        assinaturasAtivas: data.active_subscriptions,
        totalAssinaturas: data.total_subscriptions,
      });
    } catch (err) {
      console.error("Erro ao buscar métricas:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchIncompleteUsers = useCallback(async () => {
    try {
      const { data, error } = await supabase.rpc(
        "usuarios_pendentes_detalhado",
      );

      if (error) throw error;

      // Mapeia usuario_id para id (chave esperada pela UsersTable) e normaliza pendências.
      const formattedData = (data || []).map((u) => ({
        ...u,
        id: u.usuario_id,
        // Adaptando o retorno do novo RPC detalhado para o que os componentes esperam
        pendencias: {
          babas: u.missing_babas_fields || [],
          clientes: u.missing_clientes_fields || [],
        },
        problemas_detectados: u.missing_usuario_fields || [],
      }));

      setIncompleteUsers(formattedData);
    } catch (error) {
      console.error("Erro ao buscar cadastros incompletos:", error);
    }
  }, []);

  useEffect(() => {
    fetchIncompleteUsers();
  }, [fetchIncompleteUsers]);

  const fetchRegisteredUsers = useCallback(async () => {
    const { data, error } = await supabase.rpc("usuarios_completos");

    if (error) {
      console.error("Erro ao carregar usuários cadastrados:", error.message);
      setRegisteredUsers([]);
    } else {
      setRegisteredUsers(data);
    }
  }, []);

  // Função para carregar usuários com status 'enviado' (Consolidada via RPC)
  const fetchPendentesAprovacao = useCallback(async () => {
    const { data, error } = await supabase.rpc("usuarios_para_aprovacao"); // Aba Aprovações

    if (error) {
      console.error("Erro ao carregar pendentes de aprovação:", error.message);
      setFamiliasPendentes([]);
      setBabasPendentes([]);
    } else {
      const familias = (data || []).filter(
        (u) => u.tipo === "cliente" || u.tipo === "familia",
      );
      const babas = (data || []).filter(
        (u) => u.tipo === "baba" || u.tipo === "babysitter",
      );
      setFamiliasPendentes(familias);
      setBabasPendentes(babas);
    }
  }, []);

  // FONTE ÚNICA DE ATUALIZAÇÃO: recarrega todas as listas e métricas do admin
  // a partir do servidor. Toda ação (excluir, ativar/desativar, aprovar) chama
  // só isto — assim todas as abas ficam sempre consistentes, sem patch manual
  // de arrays individuais (origem histórica dos bugs de "some numa aba só").
  const refreshAdminData = useCallback(async () => {
    await Promise.all([
      fetchPendentesAprovacao(),
      fetchRegisteredUsers(),
      fetchIncompleteUsers(),
      fetchDashboardMetrics(),
    ]);
  }, [
    fetchPendentesAprovacao,
    fetchRegisteredUsers,
    fetchIncompleteUsers,
    fetchDashboardMetrics,
  ]);

  // Verifica admin e faz a carga inicial via fonte única.
  const fetchBabasAndCheckAdmin = useCallback(
    async (userId) => {
      const { data: usuario, error: userError } = await supabase.rpc(
        "rpc_get_user_auth_info",
        {
          p_user_id: userId,
        },
      );

      if (userError || (usuario?.tipo !== "admin" && !usuario?.is_admin)) {
        console.error(
          "Acesso negado: Somente administradores podem acessar esta página.",
        );
        navigate("/");
        return;
      }

      await refreshAdminData();
    },
    [navigate, refreshAdminData],
  );

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
        navigate("/login");
        return;
      }
      fetchBabasAndCheckAdmin(session.user.id);
    });
  }, [fetchBabasAndCheckAdmin, navigate]);

  // 🔹 Realtime subscription para atualização automática das listas
  useEffect(() => {
    const channel = supabase
      .channel("usuarios:refresh")
      .on("broadcast", { event: "usuarios_changed" }, (payload) => {
        console.log("📢 Refresh broadcast recebido:", payload);
        // Atualiza todas as listas e métricas do admin em tempo real
        refreshAdminData();
      })
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [refreshAdminData]);

  // Após aprovar/reprovar documentos, recarrega tudo pela fonte única —
  // o usuário reaparece na aba correta automaticamente.
  const handleStatusUpdate = () => {
    refreshAdminData();
  };

  // EXCLUSÃO PERMANENTE — confirmada pelo AlertDialog (DeleteUserAlert) antes de chamar.
  // Apaga o usuário e todos os seus dados (perfil, documentos, fotos, login) via
  // admin_hard_delete_user e o remove de TODAS as listas, sumindo em qualquer aba.
  const handleHardDeleteUser = async (userIdToDelete) => {
    const { error } = await supabase.rpc("admin_hard_delete_user", {
      target_user_id: userIdToDelete,
    });

    if (error) {
      console.error("Erro ao excluir usuário:", error.message);
      alert(`Falha ao excluir usuário: ${error.message}`);
      return;
    }

    // Limpeza best-effort dos arquivos do usuário no storage (fotos/documentos).
    // Usa a Storage API (DELETE direto em storage.objects é bloqueado pelo Supabase).
    // Nunca bloqueia: se falhar, os dados já foram excluídos do banco.
    try {
      const bucket = import.meta.env.VITE_STORAGE_DEFAULT_BUCKET || "cadastros";
      const collectPaths = async (prefix) => {
        const { data } = await supabase.storage.from(bucket).list(prefix, { limit: 100 });
        if (!data?.length) return [];
        const out = [];
        for (const item of data) {
          const full = `${prefix}/${item.name}`;
          if (item.id === null) out.push(...(await collectPaths(full)));
          else out.push(full);
        }
        return out;
      };
      const paths = await collectPaths(userIdToDelete);
      if (paths.length) await supabase.storage.from(bucket).remove(paths);
    } catch (e) {
      console.warn("Limpeza de storage ignorada (dados já excluídos):", e);
    }

    // Fonte única: recarrega todas as abas de uma vez.
    await refreshAdminData();

    alert("Usuário excluído permanentemente.");
  };

  // Aliases mantidos para os call sites existentes (Aprovações, Incompletos, Todos).
  const handleDeleteIncompleteUser = handleHardDeleteUser;
  const handleDeleteRegisteredUser = handleHardDeleteUser;

  /**
   * Toggle de ativar/desativar conta de usuário (reversível).
   * Chama admin_toggle_user_status e recarrega tudo pela fonte única.
   */
  const handleToggleUserStatus = async (userId, currentStatusConta) => {
    const newActive = currentStatusConta === false; // inverte
    const label = newActive ? "ativar" : "desativar";
    if (!window.confirm(`Confirma ${label} a conta deste usuário?`)) return;

    const { error } = await supabase.rpc("admin_toggle_user_status", {
      target_user_id: userId,
      new_active: newActive,
    });

    if (error) {
      console.error("Erro ao alterar status:", error.message);
      alert(`Falha ao ${label} a conta.`);
      return;
    }

    // Fonte única: recarrega todas as abas (reflete os filtros do servidor).
    await refreshAdminData();

    alert(`Conta ${newActive ? "ativada" : "desativada"} com sucesso.`);
  };

  // ── Ações em massa (seleção na tabela) ────────────────────────────────
  // Rodam sequencialmente e sincronizam tudo uma vez pela fonte única.
  const handleBulkDelete = async (ids = []) => {
    if (!ids.length) return;
    let ok = 0;
    let fail = 0;
    for (const id of ids) {
      const { error } = await supabase.rpc("admin_hard_delete_user", {
        target_user_id: id,
      });
      if (error) {
        fail += 1;
        console.error("Falha ao excluir", id, error.message);
      } else {
        ok += 1;
      }
    }
    await refreshAdminData();
    alert(`${ok} usuário(s) excluído(s)${fail ? `, ${fail} com falha` : ""}.`);
  };

  const handleBulkToggle = async (ids = [], active) => {
    if (!ids.length) return;
    let ok = 0;
    let fail = 0;
    for (const id of ids) {
      const { error } = await supabase.rpc("admin_toggle_user_status", {
        target_user_id: id,
        new_active: active,
      });
      if (error) {
        fail += 1;
        console.error("Falha ao alterar status", id, error.message);
      } else {
        ok += 1;
      }
    }
    await refreshAdminData();
    alert(
      `${ok} conta(s) ${active ? "ativada(s)" : "desativada(s)"}${fail ? `, ${fail} com falha` : ""}.`,
    );
  };

  // Seção Financeiro: assinaturas do Mercado Pago, sincronizadas pelo webhook.
  const FinanceiroAdminContent = () => <AssinaturasMPContent />;

  const TrabalhosAdminContent = () => {
    const [agendamentos, setAgendamentos] = useState([]);
    const [busca, setBusca] = useState("");
    const [statusFiltro, setStatusFiltro] = useState("todos");

    const carregar = async () => {
      const data = await getAgendamentos();
      setAgendamentos(data || []);
    };

    useEffect(() => {
      carregar();
    }, []);

    const confirmar = async (id) => {
      await alterarStatus(id, "confirmado");
      carregar();
    };

    const concluir = async (id) => {
      await alterarStatus(id, "concluido");
      carregar();
    };

    const cancelar = async (a) => {
      const { data } = await cancelarAgendamento(a.id, a.familia_id);

      if (data?.erro) alert("❌ " + data.erro);
      else alert("✅ " + data.sucesso);

      carregar();
    };

    const agendamentosFiltrados = agendamentos.filter((a) => {
      const matchNome = a.familia?.nome
        ?.toLowerCase()
        .includes(busca.toLowerCase());

      const matchStatus = statusFiltro && statusFiltro !== "todos" ? a.status === statusFiltro : true;

      return matchNome && matchStatus;
    });

    return (
      <div className="space-y-5">
        <div>
          <h1 className="text-xl font-bold text-foreground">Painel Admin</h1>
          <p className="text-sm text-muted-foreground">Controle total dos agendamentos</p>
        </div>

        <AdminResumoCards dados={agendamentos} />

        <div className="flex flex-col sm:flex-row gap-3">
          <ShadInput
            type="text"
            placeholder="Buscar por nome..."
            onChange={(e) => setBusca(e.target.value)}
            className="flex-1"
          />
          <Select value={statusFiltro} onValueChange={setStatusFiltro}>
            <SelectTrigger className="sm:w-48">
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="todos">Todos</SelectItem>
              <SelectItem value="pendente">Pendente</SelectItem>
              <SelectItem value="confirmado">Confirmado</SelectItem>
              <SelectItem value="concluido">Concluído</SelectItem>
              <SelectItem value="cancelado">Cancelado</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <AdminAgendamentos
          dados={agendamentosFiltrados}
          onConfirmar={confirmar}
          onConcluir={concluir}
          onCancelar={cancelar}
        />
      </div>
    );
  };

  const MenuItems = [
    { name: "Dashboard", icon: <LayoutDashboard size={25} /> },
    { name: "Cadastros", icon: <Users size={25} /> },
    { name: "Produtos", icon: <Package size={25} /> },
    { name: "Financeiro", icon: <Wallet size={25} /> },
    { name: "Trabalhos", icon: <Briefcase size={25} /> },
    { name: "Atualizações", icon: <Settings size={25} /> },
  ];

  // Função para renderizar o conteúdo da seção ativa
  const renderContent = () => {
    switch (activeMenu) {
      case "Dashboard":
        return (
          <DashboardContent metrics={dashboardMetrics} loading={loading} onNavigate={(menu, subTab) => { if (subTab) setCadastrosInitialTab(subTab); setActiveMenu(menu); }} />
        );
      case "Perfil":
        return <AdminProfileSection />;
      case "Cadastros":
        return (
          <VerificacoesContent
            loading={loading}
            babasPendentes={babasPendentes}
            familiasPendentes={familiasPendentes}
            incompleteUsers={incompleteUsers}
            registeredUsers={registeredUsers}
            handleStatusUpdate={handleStatusUpdate}
            handleDeleteIncompleteUser={handleDeleteIncompleteUser}
            handleDeleteRegisteredUser={handleDeleteRegisteredUser}
            handleToggleUserStatus={handleToggleUserStatus}
            handleBulkDelete={handleBulkDelete}
            handleBulkToggle={handleBulkToggle}
            fetchRegisteredUsers={fetchRegisteredUsers}
            fetchIncompleteUsers={fetchIncompleteUsers}
            initialTab={cadastrosInitialTab}
          />
        );
      case "Solicitacoes":
        return <SolicitacoesAdminContent />;
      case "Produtos":
        return <AssinaturasAdminContent />;
      case "Trabalhos":
        return <TrabalhosAdminContent />;
      case "Financeiro":
        return <FinanceiroAdminContent />;
      case "Atualizações":
        return (
          <AtualizacoesContent
            onOpenConteudo={() => setShowConteudoModal(true)}
          />
        );
      default:
        return null;
    }
  };
  return (
    <AppShell
      role="admin"
      perfil={null}
      activeTab={activeMenu}
      onTabChange={setActiveMenu}
    >
      {renderContent()}

      <Dialog open={showConteudoModal} onOpenChange={setShowConteudoModal}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogTitle className="sr-only">Editar Sobre Nós</DialogTitle>
          <ConteudoContent />
        </DialogContent>
      </Dialog>
    </AppShell>
  );
}
